"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  book: {
    //滚装经营
    hbmx: '货表明细',
    jbxx: '基本信息',
    cs: '测算',
    hbxq: '货表详情',
    bookingManagement: '订舱管理',
    listInquiry: '货表查询',
    listInquiryId: '货表编号',
    listInquiryFunctionary: '货表负责人',
    abandon: '废弃',
    abandonRestore: '废弃还原',
    calculate: '测算',
    ChangeShipNameAndVoyage: '更换船名航次',
    DownloadImportTemplate: '下载导入模板',
    VesselName: '船名',
    VoyageNo: '航次',
    CargoListPic: '货表负责人',
    CargoListNo: '货表编号',
    Status: '状态',
    CreateDateFr: '创建日期从',
    CreateDateTo: '创建日期到',
    No: '序号',
    LoadPort: '装港',
    DischargePort: '卸港',
    ChangeVygStatus: '更改航次审批状态',
    Remark: '备注',
    CreateDate: '创建时间',
    CreateOffice: '创建部门',
    UpdatedBy: '修改人',
    UpdatedDate: '修改时间',
    Shipper: '客户',
    ContractShipper: '合同相对方',
    ContractNo: '合同号',
    Brand: '品牌',
    Model: '型号',
    Quantity: '数量',
    Length: '长(cm)',
    Width: '宽(cm)',
    Height: '高(cm)',
    SingleVolume: '单车体积（m³）',
    SingleWeight: '单车重量（KGS）',
    TotalVolume: '总体积（m³）',
    TotalWeight: '总重量 (KGS)',
    Currency: '币种',
    CargoUnit: '计费单位',
    Price: '单价',
    TotalAmount: '总金额',
    IsNewEnergy: '新能源',
    OverHightweight: '超高/超重',
    BookingStatus: '订舱状态',
    OpsConfirmsStatus: '实装状态',
    SalesPerson: '销售员',
    OldVesselName: '原船名',
    OldVoyageNo: '原航次',
    NewVesselName: '新船名',
    NewVoyageNo: '新航次',
    CreatedBy: '制单人',
    fz: '复制',
    glht: '关联合同',
    qxglht: '取消关联合同',
    qrdc: '确认订舱',
    qxdc: '取消订舱',
    gxhz: '勾选汇总',
    qrdchz: '确认订舱汇总',
    tj: '体积',
    zl: '重量',
    breakEvenPoint: '保本点',
    portName: '港口',
    unit: '单位（UNIT/CBM）',
    loadFee: '装载费用',
    loadQtyPerHour: '每小时装（台）',
    loadDailyWorkHour: '每天作业（装）时间（H）',
    dailyLoadQty: '港口作业量（装）天',
    dischargeFee: '卸载费用',
    dischargeQtyPerHour: '每小时卸（台）',
    dischargeDailyWorkHour: '每天作业（卸）时间（H）',
    dailyDischargeQty: '港口作业量（卸）天',
    waitingTime: '等待时间（天）',
    hccsgl: '航次测算管理',
    bbdgl: '保本点管理',
    bbdxx: '保本点信息',
    gkfygl: '港口费用管理',
    gkfyxx: '港口费用信息',
    estimateName: '测算名称',
    status: '状态',
    cxcs: '重新测算',
    cscm: '测算船名',
    route: '航线',
    ladenUnit: '满载UNIT',
    ladenCbm: '满载CBM',
    exchangeRate: '汇率',
    bunkerDays: '加油天',
    lowBunkerDays: '加油低硫区天',
    tceUsd: 'TCE（USD）',
    tceRmb: 'TCE（RMB）',
    cargoQty: '货量(台)',
    extraWaitTime: '额外等待时间',
    estWaitTime: '预估等待时间',
    booktable: "货表信息",
    fromBookAdd: '从货表中添加',
    commission: '佣金%',
    refuelingTime: '加油时间',
    bunkerExpenses: '燃油费用',
    rpType: '收付',
    carbonPrice: '碳排放单价',
    tecUsd: 'TCE（USD）',
    tecRmb: 'TCE（RMB）',
    dailyProfit: 'Daily Profit($/DAY)',
    netProfitUsd: 'Net Profit(USD)',
    dailyTce: 'Daily TCE($/Day)',
    breakEvenPointDay: 'Break-even point($/DAY)',
    freightCommission: '运费佣金',
    demurrageCommission: '滞期费佣金',
    totalIncome: '总收入(USD)',
    totalIncomeRmb: '总收入(RMB)',
    lodDisFee: '装/卸作业费',
    carbonTaxCost: '碳税成本',
    ohtersIncomeTotal: '其他收入',
    TTL: 'TTL Commission',
    netIncome: 'Net Income',
    totalCost: '成本合计',
    jshl: '计算货量',
    freightRate: '运价',
    freight: '运费合计',
    version: '版本号',
    calculateAverageTCE: '计算平均TCE',
    averageTCE: '平均TCE',
    voyageDays: '航次天',
    totalVoyageDays: '总航次天',
    add: '确认',
    newUsedCar: '新车/二手车',
    dateOfProduction: '出厂日期',
    mileage: '里程数'
  }
};